export var mapWorkTime = function mapWorkTime(workTime) {
  var callFrom = workTime.callFrom,
      callTo = workTime.callTo;
  var overridesByDays = (workTime.overridesByDays || []).map(function (item) {
    if (item.isWorkingDay) {
      return {
        day: item.day,
        callFrom: item.callFrom || callFrom,
        callTo: item.callTo || callTo,
        isWorkingDay: true
      };
    }

    return {
      day: item.day,
      isWorkingDay: false
    };
  });
  return {
    callFrom: callFrom,
    callTo: callTo,
    overridesByDays: overridesByDays
  };
};